module.exports = __webpack_public_path__ + "static/media/3.41b538ac.png";